import React, { FC, useState } from 'react';
import Card from 'src/components/Card';
import { Tab, Tabs } from 'src/components/Tabs';
import SwipeableViews from 'react-swipeable-views';
import ContactsSection from './scenes/ContactsSection';
import DealsSection from './scenes/DealsSection';
import TicketsSection from './scenes/TicketsSection';
import SubOfficesSection from './scenes/SubOfficesSection';
import ExternalContactsSection from './scenes/ExternalContactsSection';
import Site from 'src/interfaces/api/Site';

enum TabTypes {
  Contacts,
  Deals,
  Tickets,
  SubOffices,
  ExternalContacts,
}

const routes = [
  {
    key: TabTypes.Contacts,
    label: 'Contacts',
  },
  {
    key: TabTypes.Deals,
    label: 'Affaires',
  },
  {
    key: TabTypes.Tickets,
    label: 'Tickets',
  },
  {
    key: TabTypes.SubOffices,
    label: 'Sous-comptes',
  },
  {
    key: TabTypes.ExternalContacts,
    label: 'Contacts externes',
  },
];

interface Props {
  loading: boolean;
  openModal: Function;
  site?: Site;
  customerContacts: any;
  customerTickets: any;
  customerSubOffices: any;
  customerDeals: any;
  customerExternalContacts: any;
}

const CustomerNavigation: FC<Props> = ({
  loading,
  openModal,
  site,
  customerContacts,
  customerTickets,
  customerSubOffices,
  customerDeals,
  customerExternalContacts,
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    handlePageChange(newValue);
  };

  const handlePageChange = (newValue) => {
    setCurrentTab(newValue);
  };

  const renderTab = (index: number, keyTab: TabTypes) => {
    switch (keyTab) {
      case TabTypes.Contacts:
        return (
          <ContactsSection
            key={index}
            hidden={index !== currentTab}
            contacts={customerContacts || []}
            siteId={site?.id}
            loading={loading}
            style={{ paddingTop: 16 }}
          />
        );
      case TabTypes.Deals:
        return (
          <DealsSection
            key={index}
            hidden={index !== currentTab}
            deals={customerDeals || []}
            siteId={site?.id}
            loading={loading}
            style={{ padding: 16 }}
          />
        );
      case TabTypes.Tickets:
        return (
          <TicketsSection
            key={index}
            hidden={index !== currentTab}
            loading={loading}
            siteId={site?.id}
            tickets={customerTickets || []}
            style={{ padding: '16px 4px 4px 4px' }}
          />
        );
      case TabTypes.SubOffices:
        return (
          <SubOfficesSection
            key={index}
            hidden={index !== currentTab}
            loading={loading}
            openModal={openModal}
            subOffices={customerSubOffices || []}
          />
        );
      case TabTypes.ExternalContacts:
        return (
          <ExternalContactsSection
            key={index}
            hidden={index !== currentTab}
            externalContacts={customerExternalContacts || []}
            loading={loading}
          />
        );
    }
  };

  return (
    <Card>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        indicatorColor='primary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'
      >
        {routes.map((route, key) => (
          <Tab key={key} label={route.label} value={key} />
        ))}
      </Tabs>

      <SwipeableViews index={currentTab} onChangeIndex={handlePageChange}>
        {routes.map((route, index) => renderTab(index, route.key))}
      </SwipeableViews>
    </Card>
  );
};

export default CustomerNavigation;
